import { isOpenPartnerOrderStatusModal } from "@/atoms/order/is-open-partner-order-status-modal1";
import {
  OrderStatus,
  OrderStatusDisplayNames,
} from "@/common/enum/order-status";
import {
  PaymentStatus,
  paymentStatusDisplayNames,
} from "@/common/enum/payment-status";
import { PaymentType } from "@/common/enum/payment-type";
import { formatDateToYYYYMMDDhhmm9 } from "@/common/util/date-util";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Strong } from "@/components/typography/Body14Strong";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Table } from "flowbite-react";
import { useRecoilState } from "recoil";
import { CustomCell } from "../CustomCell";

interface Props {
  orderDetail: OrderDetailDto;
}

export const PartnerOrderDetailHeaderTable: React.FC<Props> = ({
  orderDetail,
}) => {
  const [_, setisPartnerOrderStatusModalOpen] = useRecoilState(
    isOpenPartnerOrderStatusModal
  );
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";
  const paymentStatus = orderDetail.payment.status;
  const isPayLater = orderDetail.payment.paymentMethod === PaymentType.PALT;
  const isTaxProcessed = orderDetail.status === OrderStatus.TAX_PROCESSED;

  // TODO PDF 연동
  const handleSavePaymentStatement = () => {};

  const handleOrderStatusClick = () => {
    setisPartnerOrderStatusModalOpen(true);
  };

  const handleClickInvoiceButton = () => {
    const paymentMethod = orderDetail.payment.paymentMethod; // 결제 방식
    const paymentTno = orderDetail.payment.tno; // NHN KCP 거래번호
    const orderId = orderDetail.invoiceNumber; // 주문번호
    const amount = orderDetail.payment.amount; // 거래금액

    // 신용카드
    if (paymentMethod === "PACA") {
      window.open(
        `https://partner.kcp.co.kr/bill/card?cmd=card_bill&C_TRADE_NO=${paymentTno}&ORDER_NO=${orderId}&TRADE_MONY=${amount}`,
        "noopener,noreferrer"
      );
    }
    // 계좌이체
    if (paymentMethod === "PABK") {
      window.open(
        `https://partner.kcp.co.kr/bill/acnt?cmd=acnt_bill&A_TRADE_NO=${paymentTno}&ORDER_NO=${orderId}&TRADE_MONY=${amount}`,
        "noopener,noreferrer"
      );
    }
    // 가상계좌
    if (paymentMethod === "PAVC") {
      window.open(
        `https://partner.kcp.co.kr/bill/vcnt?cmd=vcnt_bill&V_TRADE_NO=${paymentTno}&ORDER_NO=${orderId}&TRADE_MONY=${amount}`,
        "noopener,noreferrer"
      );
    }
  };

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="rounded-lg border overflow-hidden">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    공사명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[480px] bg-primary-white">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.constructionName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    공종명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[480px] bg-primary-white">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.constructionWorkName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary ">
                    현재 상태
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[480px] bg-primary-white">
                <CustomCell>
                  <div onClick={handleOrderStatusClick}>
                    <Body14Underline className="text-semantic-text-body cursor-pointer">
                      {OrderStatusDisplayNames[orderDetail.status]}
                    </Body14Underline>
                  </div>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    결제 상태
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[415px] bg-primary-white">
                <CustomCell className="flex justify-between">
                  <div className="flex gap-[8px]">
                    {isPayLater && isTaxProcessed ? (
                      <Body14Regular
                        className={"text-semantic-text-error-primary"}
                      >
                        세금계산서 발행 완료
                      </Body14Regular>
                    ) : (
                      <>
                        <Body14Regular
                          className={
                            paymentStatus === PaymentStatus.PENDING
                              ? "text-semantic-text-error-primary"
                              : "text-semantic-text-body"
                          }
                        >
                          {paymentStatusDisplayNames[paymentStatus]}
                        </Body14Regular>

                        {paymentStatus === PaymentStatus.COMPLETED && (
                          <Body14Regular className="text-semantic-text-tertiary">
                            {orderDetail.payment.completedAt &&
                              formatDateToYYYYMMDDhhmm9(
                                orderDetail.payment.completedAt
                              )}
                          </Body14Regular>
                        )}
                      </>
                    )}
                  </div>
                  {paymentStatus === PaymentStatus.COMPLETED && (
                    <div onClick={handleClickInvoiceButton}>
                      <Body14Strong className="text-semantic-link cursor-pointer">
                        매출전표 보기
                      </Body14Strong>
                    </div>
                  )}
                </CustomCell>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};
